import PickOneRecord from "slotworks/model/gameplay/records/pick-one-record";

export default class BonusRecord extends PickOneRecord {
    public jackpotSymbol: string = "";
    public retriggers: number;
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/schema/bonus-record.ts